import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import styled from 'styled-components';

import formatCurrency from '../../../utils/formatCurrency';

interface Props {
	displayBalance: string;
	bonuses: Array<{
		amount: number;
		name: string;
		icon: string;
		type: string;
	}>;
	hideBalance: boolean;
	toggleHideBalance: () => void;
}

const RewardSection = ({ displayBalance, bonuses, hideBalance, toggleHideBalance }: Props) => {
	return (
		<>
			<RewardCell onClick={toggleHideBalance} $clickable>
				<span>Balance {hideBalance ? <FaEyeSlash size={18} /> : <FaEye size={18} />}</span>
				<strong>{displayBalance}</strong>
			</RewardCell>
			{bonuses.map(({ amount, icon, name, type }) => (
				<RewardCell key={name}>
					<span>
						{name} <img src={icon} alt={name} />
					</span>
					<strong>{type === 'cash' ? formatCurrency(amount) : amount}</strong>
				</RewardCell>
			))}
		</>
	);
};

export default RewardSection;

const RewardCell = styled.div<{ $clickable?: boolean }>`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 10px 0;
	cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

	&:not(:last-of-type) {
		border-right: 1px solid ${({ theme }) => theme.colors.lightGreyR};
	}

	span {
		color: ${({ theme }) => theme.colors.lightGrey};
		font-size: 0.8rem;
	}

	strong {
		color: ${({ theme }) => theme.colors.darkGrey};
		font-weight: 600;
		font-size: 1.2rem;
		margin-top: 5px;
		letter-spacing: 0.5px;
	}

	img,
	svg {
		display: inline;
		margin-left: 5px;
	}

	img {
		height: 14px;
	}

	svg {
		color: #a4a6a8;
	}
`;
